module.exports = __webpack_public_path__ + "media/images/footer_youtube-5547a2f7e05422bcc22632e3d094ca6e.svg";